import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/main.scss'

import { format } from 'date-fns';

Vue.config.productionTip = false;

Vue.filter('formatDateLocal', (date: string | number | Date) => {
  return date ? format(date, 'MM/DD/YYYY') : '';
});
Vue.filter('formatDatetimeLocal', (date: string | number | Date) => {
  return date ? format(date, 'MM/DD/YYYY HH:mm:ss') : '';
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
